import React from "react";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import LocalShipping from "@material-ui/icons/LocalShipping";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Heading from "components/Heading/Heading.js";
import Timeline from "components/Timeline/Timeline.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

const GRAPHQL_URL = (process.env.REACT_APP_API_URL || "http://localhost:5001") + "/graphql";

function gql(query, variables) {
  const token = localStorage.getItem("token");
  return fetch(GRAPHQL_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: token ? `Bearer ${token}` : "" },
    credentials: "include",
    body: JSON.stringify({ query, variables }),
  }).then((r) => r.json());
}

function formatNum(val) {
  if (val >= 1000000) return (val / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  if (val >= 1000) return (val / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  return Number(val || 0).toLocaleString("vi-VN");
}

function timeAgo(isoString) {
  if (!isoString) return "";
  const diff = Date.now() - new Date(isoString).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins} minute${mins !== 1 ? "s" : ""} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs !== 1 ? "s" : ""} ago`;
  const days = Math.floor(hrs / 24);
  return `${days} day${days !== 1 ? "s" : ""} ago`;
}

function buildStories(activities) {
  return activities.map((act) => {
    const hasDelivery = act.deliveryStatus && act.deliveryStatus !== "";
    const action = hasDelivery ? "sold with delivery" : "created an invoice";
    const badgeColor = hasDelivery ? "warning" : "info";
    const BadgeIcon = hasDelivery ? LocalShipping : ShoppingCart;

    return {
      badgeColor,
      badgeIcon: BadgeIcon,
      body: (
        <p style={{ margin: 0, fontSize: "14px", color: "#333" }}>
          <span style={{ color: "#1976d2", fontWeight: 600 }}>{act.creatorName}</span>
          {" just "}
          <span style={{ color: "#1976d2" }}>{action}</span>
          {" with a total of "}
          <strong>{formatNum(act.total)}</strong>
        </p>
      ),
      footer: (
        <span style={{ fontSize: "12px", color: "#aaa" }}>{timeAgo(act.invoiceDate)}</span>
      ),
    };
  });
}

export default function RecentActivitiesPage() {
  const [stories, setStories] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    gql(
      `query Q($limit:Float!){recentActivities(limit:$limit){invoiceId invoiceNumber invoiceDate creatorName total deliveryStatus status}}`,
      { limit: 30 }
    )
      .then(({ data }) => {
        const activities = data?.recentActivities || [];
        setStories(buildStories(activities));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Heading title="Recent activities" textAlign="center" />
      <GridContainer>
        <GridItem xs={12} sm={10} md={8} lg={6} style={{ margin: "0 auto" }}>
          <Card plain>
            <CardBody plain>
              {loading ? (
                <p style={{ textAlign: "center", color: "#aaa" }}>Loading...</p>
              ) : stories.length === 0 ? (
                <p style={{ textAlign: "center", color: "#aaa" }}>No recent activities</p>
              ) : (
                <Timeline stories={stories} simple />
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
